export const equalDynamicUrl = (url, targetUrl) => {
    const targetParams = targetUrl.split('/');
    const urlParams = url.split('/');
    if (targetParams.length !== urlParams.length) {
        return;
    }
    const replaceUrl = urlParams.reduce((a, c, i) => [...a, c.startsWith(':') ? targetParams[i] : c], []);
    return replaceUrl.join('/');
};
export const dedupeArrayObject = (arr, path) => {
    const map = new Map();
    for (const item of arr) {
        if (!map.has(item[path])) {
            map.set(item[path], item);
        }
    }
    return [...map.values()];
};
export const mergeArrayObject = (a, b, p) => a.filter((aa) => !b.find((bb) => aa[p] === bb[p])).concat(b);
export const createDownload = (hrefOrBlob, filename = '') => {
    const anchor = document.createElement('a');
    anchor.setAttribute('href', typeof hrefOrBlob === 'string'
        ? hrefOrBlob
        : URL.createObjectURL(hrefOrBlob));
    anchor.setAttribute('download', filename);
    document.body.appendChild(anchor);
    const event = document.createEvent('MouseEvents');
    event.initEvent('click', false, false);
    anchor.dispatchEvent(event);
    anchor.remove();
};
